<template>
    <div>
		<!-- RENEGOCIAÇÃO -->
        <modal v-model="renegotiationModal" @hide="resetRenegotiationModal" size="lg">
            <span slot="title">Renegociação</span>
			Valor a ser negociado: <strong>R$ {{formatMoney(checkedParcelsRenegotiation.map((cP) => cP.value).reduce((a, b) => a + b, 0))}}</strong>
			<br> PRÓXIMO VENCIMENTO
			<br> NÚMERO DE PARCELAS
			<br> PERIODICIDADE

			VALOR DE ENTRADA PODE SER DIFERENTE DAS DEMAIS PARCELAS
			PERMITIR ALTERAÇÃO DE VENCIMENTO DAS PARCELAS GERADAS
			COLOCAR PLAN O DE CONTAS
			SALVAR ACORDO PARA GERAR CONTRATO



            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label class="control-label">Paciente</label>
                        <!-- <select class="form-control" v-model="transaction.provider_id">
                            <option :value="null">Selecione</option>
                            <option v-for="(provider, index) in providers" :key="'providers_'+index" :value="provider.id">{{ provider.trading_name}}</option>
                        </select> -->
                    </div>
				</div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <label class="control-label">Valor</label>
						<!-- <currency-input class="form-control" :valueRange="{ min: 0 }" v-model="transaction.value" currency="BRL" :allow-negative="false" :auto-decimal-mode="true" :distraction-free="false"/> -->
					</div>
				</div>
                <div class="col-lg-3">
					<div class="form-group">
					<!-- <div :class="[ $v.transaction.expiration_date.dateRange && $v.transaction.expiration_date.required ? '' : 'has-error', 'form-group',  ]"> -->
                        <label class="control-label">Próx. Vencimento</label>
						<!-- <input type="date" class="form-control" v-model="transaction.expiration_date"> -->
                    </div>
				</div>
			</div>

            <div class="row">
				<div class="col-lg-2">
                    <div class="form-group">
                        <label class="control-label">Frequência</label><br>
                        <!-- <select class="form-control" v-model="transaction.frequency">
                            <option value="monthly">Mensal</option>
                            <option value="biweekly">Quinzenal</option>
                            <option value="weekly">Semanal</option>
                        </select> -->
                    </div>
                </div>
				<div class="col-lg-2">
                    <div class="form-group">
                    <!-- <div :class="[ $v.transaction.parcelsNumber.required && $v.transaction.parcelsNumber.minValue ? '' : 'has-error', 'form-group',  ]"> -->
                        <label class="control-label">Nº de Parcelas</label><br>
						<!-- <input type="number" class="form-control" v-model="transaction.parcelsNumber"> -->
					</div>
				</div>

				<div class="col-lg-10">
                    <div class="form-group">
                    <!-- <div :class="[ $v.transaction.observation.required ? '' : 'has-error', 'form-group',  ]"> -->
						<label>Descrição</label>
						<!-- <textarea v-model="transaction.observation" class="form-control" name="observation" rows="1"></textarea> -->
					</div>
				</div>
			</div>
			<div slot="footer">
				<btn @click="renegotiationModal = false">Cancelar</btn>
				<!-- <btn type="primary" @click="saveTransaction" :disabled="$v.transaction.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Efetuar Lançamento</btn> -->
			</div>

		</modal>

        <modal v-model="receiveParcelsModal" @hide="resetReceiveParcelsModal" size="lg">
            <span slot="title">{{ titleReceiveParcelsModal }}</span>

            <div class="row">
                <div class="col-lg-12">
                    <table class="table table-condensed">
                        <thead>
                            <tr>
                                <th>Cód.</th>
                                <th>Nome</th>
                                <th>Vencimento</th>
                                <th>Valor</th>
                                <th>Del</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(parcel,index) in $v.checkedParcelsReceive.$each.$iter" :key="`${index}_parcel`">
                                <th scope="row">{{parcel.id.$model}}</th>
                                <td>{{parcel.patient.name.$model}}</td>
                                <td>{{formatDate(parcel.expiration_date.$model)}}</td>
                                <td>R$ {{formatMoney(parcel.value.$model)}}</td>
								<td><i @click="removeParcel(index)" class="fa fa-minus" aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <td colspan="2"> </td>
                                <td class="text-right"><strong>TOTAL</strong></td>
                                <td colspan="2"><strong>R$ {{formatMoney(checkedParcelsReceive.map((cP) => cP.value).reduce((a, b) => a + b, 0))}}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                    <hr>
                </div>    
            </div>
            <div class="row">
                <div class="col-lg-3" v-for="(typePayment,i) in typePayments" :key="`${i}_typePayment`">
                    <div class="form-group">
                        <label class="control-label">{{typePayment.type_payment}}</label>
                        <currency-input class="form-control" @input="calculateTotalPay" :valueRange="{ min: 0 }" v-model="typePayment.value" currency="BRL" :allow-negative="false" :auto-decimal-mode="true" :distraction-free="false"/>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <div class="col-lg-3">
                    <div class="form-group">
                        <label class="control-label">TOTAL PAGO</label>
                        <currency-input disabled class="form-control" v-model="totalPay" currency="BRL" :allow-negative="false" :auto-decimal-mode="true" :distraction-free="false"/>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <label class="control-label">TROCO</label>
                        <currency-input disabled class="form-control" v-model="change" currency="BRL" :allow-negative="false" :auto-decimal-mode="true" :distraction-free="false"/>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group"> <br>
						<btn @click="receiveParcelsModal = false">Cancelar</btn>
					</div>
				</div>
                <div class="col-lg-3">
                    <div class="form-group"> <br>
						<btn type="primary" :disabled="disabledReceiveButton" @click="receiveParcels"><i class="fa fa-save" aria-hidden="true"></i> {{ okTextReceiveParcelsModal }}</btn>
					</div>
				</div>
            </div>
        </modal>

        <div class="box box-default">
            <!-- <div class="box-header with-border">
                <i class="fa fa-arrow-circle-up"></i><h3 class="box-title">Contas a receber</h3>
            </div> -->

            <div class="box-header with-border">
                <div class="btn-toolbar">
                    <h3 class="box-title"><i class="fa fa-arrow-circle-up"></i> Contas a Receber</h3>
                    <btn type="primary" class="pull-right" @click="handleRenegotiationModal"><i class="fa fa-plus" aria-hidden="true"></i> Acordo</btn>
                    <btn type="primary" class="pull-right" @click="handleReceiveParcelsModal"><i class="fa fa-dollar" aria-hidden="true"></i> Receber</btn>
                </div>
            </div>

            <div class="box-body">
                <datatable-component 
					search-placeholder-prop="Buscar por nome, cpf..." ref="dataTables" class="mt-3"
					:columns-prop="columns"
					url-prop="/transactions/get/receive/all"
					:select-x-prop="{
						label: 'Tipo',
						options: [
							{value: 'patient', text: 'Paciente', selected: true},
							{value: 'responsible', text: 'Responsável'}
						]
					}"
					@changeSelectx="changeSelectx"
					:tableDataSendRequestProp="{}"
					default-order-prop="expiration_date"
					default-order-dir="asc">
                    <template v-slot:afterHeader="{}">
                        <tr>
							<td colspan="4">
								<input type="checkbox" v-model="checkAll" id="checkAll"> <label for="checkAll"> {{!checkAll ? 'Selecionar tudo' : 'Limpar seleção'}}</label>
							</td>
							<td colspan="5">
								<span v-if="checkedParcels.length">
									<btn @click="checkAll = null; checkedParcels = []" type="warning" size="small" class="pull-right"><i class="fa fa-minus" aria-hidden="true"></i> Limpar seleção</btn>
									<span class="pull-right" style="margin-right:10px"> 
										{{ checkedParcels.length }} parcela(s) selecionada(s) | <strong>Total: R$ {{formatMoney(checkedParcels.map((cP) => cP.value).reduce((a, b) => a + b, 0))}}</strong> 
									</span>
								</span>
							</td>
						</tr>
                    </template>
                    <template v-slot:name="{data}">
						<i v-if="selectx === 'patient' && data.patient.responsible" class="fa fa-exclamation-circle" aria-hidden="true" alt="oioioioio"></i>
                        {{data.patient ? data.patient.name : ''}}
                    </template>
                    <template v-slot:codePatient="{ data }">
						{{ data.patient.code }}
                    </template>
                    <template v-slot:responsible="{ data }">
						{{ data.patient.responsible ? data.patient.responsible.name : '--' }}
                    </template>
                    <template v-slot:delay="{data}">
                        {{ delayDays(data.expiration_date) }}
                    </template>
                    <template v-slot:checkbox="data">
                        <input v-if="data.data.situation === 'PENDING'" type="checkbox" :value="data.data" v-model="checkedParcels">
                    </template>
                    <template v-slot:noResult>
                        Faça uma busca no campo acima. Nenhum resultado a ser mostrado.
                    </template>
                    <template v-slot:action="{data}">
                        <li class="m-1"><a :href="'/patient/'+data.patient.id+'/edit'" title="Ver prontuário"><i class="fa fa-search" aria-hidden="true"></i> Ver prontuário</a></li>
                        <li v-if="data.budget" class="m-1"><a :href="'/budget/'+data.budget.id+'/edit'" title="Ver orçamento"><i class="fa fa-search" aria-hidden="true"></i> Ver orçamento</a></li>
                        <!-- <li class="m-1" @click="deleteDentalPlan(data.data)"><a href="javascript:void(0)" title="Excluir"><i class="fa fa-trash" aria-hidden="true"></i> Excluir</a></li> -->
                    </template>
                </datatable-component>
            </div>
        </div>
    </div>
</template>

<script>
    import {required, minValue, requiredIf} from "vuelidate/lib/validators";
    import { CurrencyInput } from 'vue-currency-input'
    import DatatableComponent from "../../datatable/datatable-component";

    export default {
        name: "BillsToReceive",
        components: { CurrencyInput, DatatableComponent },
        props:{
            type_payments: { type: Array, default: () => [] }
        },
        watch: {
			checkAll: function (value, lastValue) {
				if (value) this.checkedParcels = _.cloneDeep(this.$refs.dataTables.apiData)
				else this.checkedParcels = []
			},
		},
        data () {
			return {
				optionsToast: { timeout: 6000, position: "topCenter" },
				payload: {},
				columns: [],
				columnsPatient:[
					{ width: '5%', label: '#', name: 'checkbox', type: 'Slot', sortable: false },
					{ width: '5%', label: 'CÓD.', name: 'codePatient', type: 'Slot', sortable: false },
					{
						width: '5%', label: 'CONTRATO', name: 'patient', type: 'ObjectMultiDimensional',
						key:'contract',
						key2:'code',
						empty:'--',
						sortable: true 
					},
					{ width: '30%', label: 'PACIENTE', name: 'name', type: 'Slot', sortable: false },
					{ width: '10%', label: 'VENCIMENTO', name: 'expiration_date', type: 'Date', sortable: true },
					{ width: '10%', label: 'ATRASO', name: 'delay', type: 'Slot', sortable: false },
					{ width: '10%', label: 'VALOR', name: 'value', type: 'Currency', sortable: true },
					{ width: '30%', label: 'DESCRIÇÃO', name: 'observation', type: 'String', sortable: false },
					{ width: '5%', label: 'AÇÃO', name: 'action', type: 'action', sortable: false },
				],
				
				columnsResponsible:[
					{ width: '5%', label: '#', name: 'checkbox', type: 'Slot', sortable: false },
					{ width: '5%', label: 'CÓD.', name: 'codePatient', type: 'Slot', sortable: false },
					{
						width: '5%', label: 'CONTRATO', name: 'patient', type: 'ObjectMultiDimensional',
						key:'contract',
						key2:'code',
						empty:'--',
						sortable: true 
					},
					{ width: '15%', label: 'RESPONSÁVEL', name: 'responsible', type: 'Slot', sortable: false },
					{ width: '15%', label: 'PACIENTE', name: 'name', type: 'Slot', sortable: false },
					{ width: '10%', label: 'VENCIMENTO', name: 'expiration_date', type: 'Date', sortable: true },
					{ width: '10%', label: 'ATRASO', name: 'delay', type: 'Slot', sortable: false },
					{ width: '10%', label: 'VALOR', name: 'value', type: 'Currency', sortable: true },
					{ width: '30%', label: 'DESCRIÇÃO', name: 'observation', type: 'String', sortable: false },
					{ width: '5%', label: 'AÇÃO', name: 'action', type: 'action', sortable: false },
				],

				selectx: '',

				disabledReceiveButton: true,
				typePayments: this.type_payments,

				receiveParcelsModal: false,
				titleReceiveParcelsModal: '',
				okTextReceiveParcelsModal: '',
				checkAll: false,
				checkedParcels: [],
				checkedParcelsReceive: [],
				totalPay: 0,
				change: 0,

				renegotiationModal: false,
				checkedParcelsRenegotiation: []
			}
        },

        validations: {
			checkedParcelsReceive: {
				$each: {
					id: {},
					parcel: {required, minValue: minValue(1)},
					expiration_date: {
						dateRange: date => {
							if (date && date.length === 10) {
									return moment(date, "YYYY-MM-DD").isBetween('1901-01-01', '2200-12-31', null, '[]')
							} else if (date && date.length > 10) {
									return false
							}
							return true
						}, required,
					},
					patient:{
							name: {}
					},
					value: {required, minValue: minValue(0)},
					// payday: {
					//     requiredIf: requiredIf( items => items.situation === 'PAID' ),
					//     dateRange: (date, items) => {
					//         if (date && date.length === 10 && items.situation === 'PAID') {
					//             return moment(date, "YYYY-MM-DD").isBetween('1901-01-01', '2200-12-31', null, '[]')
					//         } else if (date && date.length > 10) {
					//             return false
					//         }
					//         return true
					//     },
					// },
				}
			},
        },

        methods: {
			delayDays (expiration_date) {
				const delayDays = moment().diff(expiration_date,'days')
				if(delayDays > 0) {
					return delayDays
				} else {
					return '--'
				}
			},

			changeSelectx(selectx) {
				this.selectx = selectx
				this.columns = selectx === 'patient' ?  this.columnsPatient : this.columnsResponsible
			},

			removeParcel (i) {
				this.checkedParcelsReceive.splice(i, 1) //Removo de parcelas a receber 
				this.checkedParcels.splice(i, 1) //Desmarco de parcelas selecionadas
			},
			
			handleRenegotiationModal () {
				if (this.checkedParcels.length == 0) {
					this.$toast.warning('Selecione ao menos uma parcela para renegociar.', 'AVISO', this.optionsToast);
					return
				}

				this.checkedParcelsRenegotiation = _.cloneDeep(this.checkedParcels);

				//VERIFICAR SE TODAS AS PARCELAS SÃO DE UM ÚNICO PACIENTE
				if (this.checkedParcelsRenegotiation.find(a => a.patient_id !== this.checkedParcelsRenegotiation[0].patient_id)) {
					this.$toast.warning('TODAS as parcelas devem pertencer ao mesmo paciente.', 'AVISO', this.optionsToast);
					return
				}

				this.renegotiationModal = true
				
			},

			handleReceiveParcelsModal () {
				if (this.checkedParcels.length == 0) {
					this.$toast.warning('Selecione ao menos uma parcela para receber.', 'AVISO', this.optionsToast);
					return false
				}

				this.checkedParcelsReceive = _.cloneDeep(this.checkedParcels);

				this.titleReceiveParcelsModal = 'Recebimento',
				this.okTextReceiveParcelsModal = 'Confirmar recebimento',
				this.receiveParcelsModal = true
			},
			async receiveParcels () {
				try {
					this.payload = {
						parcels: this.checkedParcelsReceive,
						type_payments: this.typePayments.filter(a => a.value > 0), //passo somente tipos de pagamento com valor maior que zero
						totalPay: this.totalPay,
						type: 'CREDIT',
						change: this.change
					}
					const response = await axios.post('/transactions/receive', this.payload);
					this.checkedParcelsReceive = [] //Desmarco parcelas a receber 
					this.checkedParcels = [] //Desmarco parcelas selecionadas
					this.$refs.dataTables.reload()
					this.$toast.success(response.data.message, response.data.title, this.optionsToast);
					this.receiveParcelsModal = false
	            } catch (err) {
					console.log(err);
    	        }
			},
			resetReceiveParcelsModal () {
				this.typePayments = this.type_payments.map((tp => {
					tp.value = 0
					return tp
				}))
				this.totalPay = 0,
				this.change = 0
			},
			resetRenegotiationModal () {
				console.log('resetRenegotiationModal')
			},
			calculateTotalPay () {
				this.totalPay = this.typePayments.map((tP) => tP.value).reduce((a, b) => a + b, 0)
				const total = this.checkedParcelsReceive.map((cP) => cP.value).reduce((a, b) => a + b, 0)
				//bloquieo do botão receber evitando recebimento de valor menor que o devido
				this.disabledReceiveButton = !!(this.totalPay < total)
				//TROCO
				const change = this.totalPay - (total)
				this.change = change < 0 ? 0 : change
			},
			formatDate(dateTimeString = null, type = 'date') {
				if(dateTimeString) {
					if(type == 'date'){ // A data passada deve estar no padrão: YYYY-MM-DD
						const [YYYY, MM, DD] = (dateTimeString.slice(0,10)).split('-');
						return `${DD}/${MM}/${YYYY}`;
					} else if(type == 'time'){
						return dateTimeString
					} else if(type == 'dateTime'){ // A data passada deve estar no padrão: YYYY-MM-DD HH:mm:ss
						const [YYYY, MM, DD] = (dateTimeString.slice(0,10)).split('-');
						const [H, m, s] = (dateTimeString.slice(11,19)).split(':');
						return `${DD}/${MM}/${YYYY} ${H}:${m}:${s}`;
					}
					return dateTimeString

					// // DD/MM/YYYY HH:mm:ss
					// // Primeiro, dividimos a data completa em duas partes:
					// const [date, time] = dateTimeString.split(' ');
					//
					//
					// // Dividimos o tempo em hora e minutos:
					// const [HH, mm, ss] = time.split(':');
					//
					// // Retornamos a data formatada em um padrão compatível com ISO:
					// return `${DD}/${MM}/${YYYY}T${HH}:${mm}:${ss}`;
				}
				return '';
			},
			formatMoney(amount, decimalCount = 2, decimal = ",", thousands = ".") {
				try {
					decimalCount = Math.abs(decimalCount);
					decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

					const negativeSign = amount < 0 ? "-" : "";

					let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
					let j = (i.length > 3) ? i.length % 3 : 0;

					return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
				} catch (e) {
					console.log(e)
				}
			},
		},
		mounted () {
			this.typePayments = this.type_payments.map((tp => {
				tp.value = 0
				return tp
			}))

			this.selectx = this.$refs.dataTables.tableData.selectx
		},
		created () {
			this.columns = this.columnsPatient
		}
    }
</script>

<style>
.EXPIRED {
	/* background-color: #FFBBBB !important; */
	color: red;
}

</style>

